// extracted by mini-css-extract-plugin
export default {"ResourcesFilter":"dPrjjbrDVpNQUqw8_KRT"};